export const SYSTEM_TOOLS_REALM_ID = 'corp';
export const SYSTEM_TOOLS_PLATFORM_ROLES = Object.freeze([
  'platform-operator',
  'david-duncan',
] as const);

export function realmIdFromIssuer(issuer: unknown): string {
  if (typeof issuer !== 'string') return '';
  const parts = issuer.split('/').filter(Boolean);
  return (parts[parts.length - 1] ?? '').trim().toLowerCase();
}

export function hasSystemToolsAccess(realmId: unknown, roles: readonly string[]): boolean {
  const normalizedRealm = typeof realmId === 'string' ? realmId.trim().toLowerCase() : '';
  if (normalizedRealm !== SYSTEM_TOOLS_REALM_ID) return false;
  const approved = new Set<string>(SYSTEM_TOOLS_PLATFORM_ROLES);
  return roles.some((role) => approved.has(String(role).trim().toLowerCase()));
}
